/* eslint-disable */
export default {
  contactDetails: '연락처 세부 정보',
  loadingContact: '연락처 로드 중...',
  contactNotFound: '연락처를 찾을 수 없습니다.',
} as const;

// @key: @#@"contactDetails"@#@ @source: @#@"Contact Details"@#@
// @key: @#@"loadingContact"@#@ @source: @#@"Loading contact..."@#@
// @key: @#@"contactNotFound"@#@ @source: @#@"Contact not found."@#@
